'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SortableComposition = require('./SortableComposition');

Object.defineProperty(exports, 'sortable', {
  enumerable: true,
  get: function get() {
    return _SortableComposition.SortableComposition;
  }
});
Object.defineProperty(exports, 'Sortable', {
  enumerable: true,
  get: function get() {
    return _SortableComposition.SortableComposition;
  }
});